







































































































import { IPage } from '@/services/gql/generic-find';
import ListBody from '@/components/list/ListBody.vue';
import ListHead from '@/components/list/ListHead.vue';
import ListItem from '@/components/list/ListItem.vue';
import ListPager from '@/components/list/ListPager.vue';
import ListWrapper from '@/components/list/ListWrapper.vue';
import LoaderInline from '@/components/LoaderInline.vue';

export default {
  props: {
    enableSearch: Boolean,
    isLoading: Boolean,
    list: {
      type: Array,
      default: () => [],
    },
    pageNumber: {
      type: Number,
      default: 1,
    },
    pageSize: Number,
    recordCount: Number,
    route: Function,
    title: String,
  },
  mounted() {
    this.$on('page', (page: IPage) => {
      // The router does not drive the data because
      // the big loading screen displays on most list pages.
      // Maybe the route should drive all data loading but cba to refactor
      const searchName = page.query && page.query.name && page.query.name._ilike;
      const search = searchName && searchName.substr(1, searchName.length - 2);
      this.$router.replace({
        ...this.$route,
        query: {
          ...this.$route.query,
          page: page.number,
          search,
        },
      });
    });
  },
  data() {
    return {
      // set the initial search box value
      search: this.$route.query.search,
      mayHaveResults: false,
    };
  },
  computed: {
    // use this to determine whether dataset
    // has any data at all even when unfiltered
    resultsEncountered() {
      if (this.list.length) {
        this.mayHaveResults = true;

        // focus on search field on desktop
        !this.$store.state.isMobile
          && setTimeout(this.focusOnFilter, 100);
      }
    },
    searchValue: {
      get() {
        return this.search;
      },
      set(value: string) {
        // set to page 1 of results
        this.search = value;
        this.$emit('page', this.getQueryParams(1, value));
      },
    },
    localPageNumber: {
      get() {
        return this.pageNumber;
      },
      set(value: number) {
        this.$emit('page', this.getQueryParams(value, this.searchValue));
      },
    },
    pageCount() {
      return Math.ceil(this.recordCount / this.pageSize);
    },
  },
  methods: {
    getQueryParams: (pageNumber: number = 1, query: string = '') => ({
      number: pageNumber,
      query: query
        ? {
            name: {
              _ilike: `%${query}%`,
            },
          }
        : {},
    }),
    focus(event: KeyboardEvent, next: boolean) {
      const target = event.target as HTMLDivElement;
      const nextElement = next
        ? target.nextElementSibling
        : target.previousElementSibling;
      if (nextElement) {
        (nextElement as HTMLDivElement).focus();
        this.preventScroll(event);
      } else if (next === false) {
        this.focusOnFilter();
      }
    },
    focusOnFilter() {
      const filterInput = this.$refs.search;
      filterInput
        ? (filterInput as HTMLDivElement).focus()
        : this.focusOnFirstItem();
    },
    focusOnFirstItem(event?: KeyboardEvent) {
      const ref = this.$refs['option-0'];
      if (Array.isArray(ref) && ref[0]) {
        (ref[0].$el as HTMLElement).focus();
        event && this.preventScroll(event);
      }
    },
    preventScroll({ view }: KeyboardEvent) {
      // prevent scroll
      view
        && view.event
        && view.event.preventDefault();
    },
    resetSearch() {
      this.searchValue = '';
      this.$refs.search.focus();
    },
  },
  components: {
    ListBody,
    ListHead,
    ListItem,
    ListPager,
    ListWrapper,
    LoaderInline,
  },
} as IView;
